export default __webpack_public_path__ + "static/media/BABI.991b959d.png";